export default __webpack_public_path__ + "static/media/sixplus.d1302805.png";